import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/foundation/modelsList';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const params = new URLSearchParams();
    if (action.payload?.family)     params.set('family',     action.payload.family);
    if (action.payload?.task)       params.set('task',       action.payload.task);
    if (action.payload?.include_deprecated) params.set('include_deprecated', 'true');
    const url = `${config.API_URL}/models/foundation${params.toString() ? '?' + params.toString() : ''}`;
    const response = yield call(axios.get, url, { headers: getLocalUser() });
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
